import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  devider: {
    margin: theme.spacing(2, 0),
  },
  upload: {
    marginLeft: theme.spacing(19),
  },
}));

export default useStyles;
